<template>
	<AppHeader
		:logo="logo"
		:headerButton1="headerButton1"
		:headerButton2="headerButton2"
	/>

	<div class="flex-grow-1">
		<UiElement class="d-flex flex-column h-100 py-0" :settings="appearance.body.settings">
			<div class="flex-grow-1">
				<UiText :settings="text1" class="text-center">
					2/3
				</UiText>

				<UiText :settings="heading1" class="text-center">
					{{ translations?.shrnuti || '{shrnuti}' }}
				</UiText>

				<hr class="border-3" style="color: #000; opacity: 1;">

				<ProductsList :products="cart">
					<template #item="{ product }">
						<div class="d-flex align-items-start">
							<img
								src="https://cdn3.iconfinder.com/data/icons/pyconic-icons-1-2/512/close-512.png"
								class="me-4"
								width="50"
								height="50"
								alt=""
								@click="removeAllByProductId(product.id)"
							/>

							<div class="d-flex flex-row justify-content-between align-items-start flex-grow-1 pe-4">
								<UiText :settings="heading2">
									{{ product.label }}
								</UiText>

								<UiText :settings="heading2" class="ps-3">
									{{ product.price }}&nbsp;Kč
								</UiText>
							</div>

							<UiButtonAmount :product="product" :settings="general.elements.buttonAmount1.settings">
								<template #default="{ count }">
									<UiText :settings="heading4">
										{{ count }}
									</UiText>
								</template>
							</UiButtonAmount>
						</div>

						<hr class="border-3" style="color: #000; opacity: 1;">
					</template>
				</ProductsList>

				<div>
					<UiText :settings="heading3" class="text-end">
						{{ translations?.total || '{total}' }}
					</UiText>

					<hr class="border-3" style="color: #000; opacity: 1;">

					<UiText :settings="heading4" class="text-end">
						{{ total }} Kč
					</UiText>
				</div>

				<div v-if="page.options.tips.value == true">
					<UiText :settings="heading3">
						{{ translations?.tips || '{tips}' }}
					</UiText>

					<div class="d-flex justify-content-between gap-4">
						<UiButton
							v-for="option in page.options.tipsOptions.value"
							:key="`tip-option-${option}`"
							:settings="general.elements.buttonOutlined.settings" class="w-100 px-0" style="font-size: 32px" @click="tips = 0"
							:style="tips === option ? 'background: #000; color: #fff' : null"
						>
							{{ option }}% <br />({{ Math.floor(total / 100 * option) }} Kč)
						</UiButton>
					</div>
				</div>
			</div>

			<UiElement class="position-sticky bottom-0 start-0 w-100 px-0" :settings="appearance.body.settings">
				<div class="d-flex gap-4">
					<UiButtonArrow :settings="button1" :body="appearance.body.settings" class="w-50">
						{{ translations?.back || '{back}' }}
					</UiButtonArrow>

					<router-link :to="`/${route.params.kioskId}/payment`" class="w-50 text-decoration-none">
						<UiButtonArrow :settings="button2" :body="appearance.body.settings" class="w-100" right>
							{{ translations?.pay || '{pay}' }}
						</UiButtonArrow>
					</router-link>
				</div>
			</UiElement>
		</UiElement>
	</div>
</template>

<script setup>
	import { storeToRefs } from 'pinia';
	import { computed } from 'vue';
	import { useThemeStore } from '@/stores/useThemeStore';
	import { useOrderStore } from '@/stores/useOrderStore';
	import UiElement from '@/components/UI/UiElement.vue';
	import UiText from '@/components/UI/UiText.vue';
	import UiButtonArrow from '@/components/UI/UiButtonArrow.vue';
	import { useRoute } from 'vue-router';
	import ProductsList from '@/components/ProductsList.vue';
	import UiButtonAmount from '@/components/UI/UiButtonAmount.vue';
	import UiButton from '@/components/UI/UiButton.vue';
	import AppHeader from '@/components/AppHeader.vue';
	import { useInheritedSettings } from '@/composables/useInheritedSettings';
	import { useTranslationsStore } from '@/stores/useTranslationsStore';

	const route = useRoute();

	const themeStore = useThemeStore();
	const orderStore = useOrderStore();
	const translationsStore = useTranslationsStore();
	const { removeAllByProductId } = orderStore;

	const { translations } = storeToRefs(translationsStore);
	const { theme } = storeToRefs(themeStore);
	const { cart, total, tips } = storeToRefs(orderStore);

	const general = computed(() => theme.value.general);
	const page = computed(() => theme.value.pages.summary);
	const appearance = computed(() => page.value.appearance);
	const elements = computed(() => page.value.elements);

	const text1 = useInheritedSettings(computed(() => elements.value?.text1));
	const heading1 = useInheritedSettings(computed(() => elements.value?.heading1));
	const heading2 = useInheritedSettings(computed(() => elements.value?.heading2));
	const heading3 = useInheritedSettings(computed(() => elements.value?.heading3));
	const heading4 = useInheritedSettings(computed(() => elements.value?.heading4));
	const button1 = useInheritedSettings(computed(() => elements.value?.button1));
	const button2 = useInheritedSettings(computed(() => elements.value?.button2));

	const logo = useInheritedSettings(computed(() => elements.value?.logo));
	const headerButton1 = useInheritedSettings(computed(() => elements.value?.headerButton1));
	const headerButton2 = useInheritedSettings(computed(() => elements.value?.headerButton2));
</script>